import { assignSafe } from '@summit/core';
import { WageType } from '../ebo/employee/wage/wage-type.enum';

export class WageProfile {
  type: WageType;
  timeClockEnabled: boolean;

  constructor(data: Partial<WageProfile>) {
    assignSafe(this, data);
  }

  //yes this can be null here
  isEqual(other?: WageProfile): boolean {
    return this?.type === other?.type && this?.timeClockEnabled === other?.timeClockEnabled;
  }
}
